if (!customElements.get('size-guide-calculator')) {
  customElements.define(
    'size-guide-calculator',
    class SizeGuideCalculator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.form = this.querySelector('form');
        this.result = this.querySelector('.sunflower-size-guide__result');
        this.resultSize = this.querySelector('.sunflower-size-guide__result-size');
        this.resultCopy = this.querySelector('.sunflower-size-guide__result-copy');
        this.selectButton = this.querySelector('.sunflower-size-guide__select');
        this.inputs = Array.from(this.querySelectorAll('[data-size-guide-input]'));

        try {
          this.chart = JSON.parse(this.dataset.chart);
        } catch (error) {
          this.chart = [];
        }

        this.form?.addEventListener('submit', (event) => this.calculate(event));
        this.selectButton?.addEventListener('click', () => this.selectRecommendedSize());
      }

      calculate(event) {
        event.preventDefault();

        const values = {};
        const hasInvalidValue = this.inputs.some((input) => {
          const value = Number.parseFloat(input.value);
          values[input.dataset.metric] = value;
          return !Number.isFinite(value) || value <= 0;
        });

        if (hasInvalidValue || this.inputs.length === 0 || this.chart.length === 0) {
          this.showMessage('', this.dataset.invalidMessage, false);
          return;
        }

        const match =
          this.dataset.strategy === 'threshold'
            ? this.chart.find((entry) => entry.primaryMax >= values[this.inputs[0].dataset.metric])
            : this.chart.find((entry) =>
                this.inputs.every((input) => entry[input.dataset.metric] >= values[input.dataset.metric])
              );
        const recommendation = match || this.chart[this.chart.length - 1];
        const message = match
          ? this.replaceSize(this.dataset.resultTemplate, recommendation.size)
          : this.replaceSize(this.dataset.largestTemplate, recommendation.size);

        this.recommendedSize = recommendation.size;
        this.showMessage(recommendation.size, message, true);
      }

      showMessage(size, message, canSelect) {
        this.result.hidden = false;
        this.resultSize.textContent = size;
        this.resultCopy.textContent = message;
        this.selectButton.hidden = !canSelect;

        if (canSelect) {
          this.selectButton.textContent = this.replaceSize(this.dataset.selectTemplate, size);
        }
      }

      selectRecommendedSize() {
        const productInfo = this.closest('product-info') || document;
        const sizeInputs = Array.from(productInfo.querySelectorAll('input[type="radio"]'));
        const sizeInput = sizeInputs.find((input) => input.value === this.recommendedSize);
        const isUnavailable = sizeInput?.disabled || sizeInput?.classList.contains('disabled');

        if (!sizeInput || isUnavailable) {
          this.resultCopy.textContent = this.replaceSize(this.dataset.unavailableTemplate, this.recommendedSize);
          return;
        }

        sizeInput.click();
        sizeInput.focus({ preventScroll: true });
        this.resultCopy.textContent = this.replaceSize(this.dataset.selectedTemplate, this.recommendedSize);
      }

      replaceSize(template, size) {
        return (template || '').replace('[size]', size);
      }
    }
  );
}
